import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { get } from "lodash";
export var getFileExtension = function getFileExtension(path) {
  var splitArr = path.split(".");
  return get(splitArr, [splitArr.length - 1], "").toLocaleLowerCase();
};
export var defaultFormData = {
  patient_id: "",
  name: "",
  age: "",
  gender: "",
  patient_uid: "",
  contact: "",
  dob: null,
  relative_name: ""
};
export var updateFileState = function updateFileState(fileKey, updatedObject, oldSelectedObject) {
  var fileObject = oldSelectedObject[fileKey];
  if (!fileObject) {
    throw new Error("File with key \"".concat(fileKey, "\" does not exist."));
  }
  Object.entries(updatedObject).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (key && value !== undefined) {
      fileObject[key] = value;
    }
  });
};
export var toFilesObject = function toFilesObject(currentSelectedFiles, selectedFiles) {
  var currentLength = Object.keys(selectedFiles).length;
  var startIndex = currentLength || 0;
  var fileSelection = currentSelectedFiles.reduce(function (acc, file, index) {
    var fileKey = "file".concat(index + startIndex);
    var fileName = file.name;
    acc[fileKey] = {
      file: file,
      fileKey: fileKey,
      fileName: fileName,
      uploadProgress: 0,
      isSelected: true,
      isValidated: true,
      uploadComplete: false
    };
    return acc;
  }, {});
  return fileSelection;
};
export function readFile(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.addEventListener("load", function () {
      return resolve(reader.result);
    }, false);
    reader.readAsDataURL(file);
  });
}